"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ABTestsProvider = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const abtests_context_1 = require("./abtests-context");
const parse_tests_from_cookies_1 = tslib_1.__importDefault(require("./utils/parse-tests-from-cookies"));
function ABTestsProvider({ initialCookieString = (typeof document !== 'undefined' && (document === null || document === void 0 ? void 0 : document.cookie)) || '', children }) {
    const cookiesString = (0, react_1.useRef)(initialCookieString);
    const [tests, setTests] = (0, react_1.useState)(() => (0, parse_tests_from_cookies_1.default)(cookiesString.current));
    const setCookiesString = (0, react_1.useCallback)((cookies) => {
        cookiesString.current = cookies;
        const testsFromCookies = (0, parse_tests_from_cookies_1.default)(cookiesString.current);
        if (JSON.stringify(testsFromCookies) !== JSON.stringify(tests)) {
            setTests(testsFromCookies);
        }
    }, [tests]);
    const value = (0, react_1.useMemo)(() => ({
        tests, setCookiesString
    }), [tests, setCookiesString]);
    return ((0, jsx_runtime_1.jsx)(abtests_context_1.ABTestsContext.Provider, Object.assign({ value: value }, { children: children })));
}
exports.ABTestsProvider = ABTestsProvider;
//# sourceMappingURL=abtests-provider.js.map